import { SingleWFHLeaveApplyDataType, StcoToolsType } from "./stcoToolsType";

export const stcoToolsReducer = {
  resetIdPasswordManagerSuccess: (state: StcoToolsType) => {
    state.error = null;
  },
  resetIdPasswordManagerError: (state: StcoToolsType) => {
    state.success = null;
  },
  resetIdPasswordManagerList: (state: StcoToolsType) => {
    state.getidPasswordManagerList = [];
  },
  resetClientIdPasswordManagerList: (state: StcoToolsType) => {
    state.getClientidPasswordManagerList = [];
  },
  resetIdPasswordManagerMessage: (state: StcoToolsType) => {
    state.message = null;
  },
  resetIdPasswordManagerStatusCode: (state: StcoToolsType) => {
    state.statusCode = null;
  },
  resetTotalUserCountList: (state: StcoToolsType) => {
    state.totalUserCountList = null;
  },
  resetTotalClientCountList: (state: StcoToolsType) => {
    state.totalClientList = null;
  },
  resetStcoToolsSuccess: (state: StcoToolsType) => {
    state.error = null;
  },
  resetStcoToolsError: (state: StcoToolsType) => {
    state.success = null;
  },
  resetStcoToolsMessage: (state: StcoToolsType) => {
    state.message = null;
  },
  resetStcoToolsStatusCode: (state: StcoToolsType) => {
    state.statusCode = null;
  },
  resetUpcomingLeaveList: (state: StcoToolsType) => {
    state.upcomingList = [];
  },
  resetLeaveAndWFHList: (state: StcoToolsType) => {
    state.leaveAndWFHHistoryList = [];
  },
  resetSingleLeaveAndWFHApplyData: (state: StcoToolsType) => {
    state.singleLeaveAndWFHApplyData = {} as SingleWFHLeaveApplyDataType;
  },
  resetGstRegisterMessage: (state: StcoToolsType) => {
    state.gstRegisterMessage = null;
  },
  resetIsGstRegisteredVerifyData: (state: StcoToolsType) => {
    state.isGstRegisteredVerifyData = {};
  },
  resetGstRegisterSuccess: (state: StcoToolsType) => {
    state.gstRegisterSuccess = null;
  },
  resetStcoToolsFetching: (state: StcoToolsType) => {
    state.fetching = false;
  },
  resetUploadedFiles:(state:StcoToolsType)=>{
    state.fileUploadData=[]

  },
  resetSasTokenForDownloadFile:(state:StcoToolsType)=>{
    state.sasTokenForDownloadFile=""
  },
};

